// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".server-notifs{direction:rtl;bottom:40px !important}.server-notifs .notification-content{text-align:right}.server-notifs.lang-en{direction:ltr}.server-notifs.lang-en .notification-content{text-align:left}", ""]);
// Exports
module.exports = exports;
